import { useAppSelector } from "@/shared/hooks";
import styles from "./UserMainInfo.module.scss";
import { Title, UserAvatar } from "@/shared";
import EditPenIcon from "@/shared/assets/editPenIcon.svg";
import { useDrawer } from "@/app/providers/DrawerProvider/useDrawer";
import { EditUserForm } from "../forms/editUserForm/EditUserForm";
import { FC } from "react";
import { IUser } from "@/entities/users/types";

interface UserMainInfoProps {
  user: IUser;
}

export const UserMainInfo: FC<UserMainInfoProps> = ({ user }) => {
  const { roleName, isTechAdmin } = useAppSelector((state) => state.viewer);
  const { currentDealer } = useAppSelector((state) => state.dealers);

  const { openDrawer } = useDrawer();
  const canEdit =
    roleName !== "Sales" && roleName !== "Marketer" && !isTechAdmin;
  const handleOpenUserEdit = () => {
    openDrawer(
      <>
        <Title text="Редактировать данные" type="default" />
        <EditUserForm
          currentUser={user}
          viewType={currentDealer ? "dealer" : "skad"}
        />
      </>,
      {},
    );
  };

  return (
    <div className={styles.top}>
      <div className={styles.topLeft}>
        <div className={styles.photo}>
          <UserAvatar fio={user.fio} image={user.image} />
        </div>
        <p>{user.fio}</p>
      </div>
      {canEdit && (
        <div className={styles.icon} onClick={handleOpenUserEdit}>
          <EditPenIcon />
        </div>
      )}
    </div>
  );
};
